import { useForkRef } from '@mui/material/utils';
import { Ref, forwardRef, useRef } from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import pt from 'react-phone-input-2/lang/pt.json';
import 'react-phone-input-2/lib/material.css';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import { useCountryFlagStyles } from './hooks/useCountryFlagStyles';
import { useCountryListPosition } from './hooks/useCountryListPosition';
import { usePhoneFieldStyles } from './phoneField.styles';

type PhoneFieldProps = PhoneInputProps & {
  inputRef: Ref<unknown> | undefined;
  inputProps?: { ref?: Ref<HTMLInputElement> };
};

const PhoneField = forwardRef<HTMLInputElement, PhoneFieldProps>((props, ref) => {
  const { isPortuguese } = useTranslation();
  const localization = isPortuguese ? pt : undefined;
  const { classes } = usePhoneFieldStyles();
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const inputRef = useForkRef(phoneInputRef, props.inputProps?.ref, ref);

  useCountryListPosition(phoneInputRef);
  useCountryFlagStyles();

  return (
    <PhoneInput
      specialLabel=""
      {...props}
      inputProps={{ ...props.inputProps, ref: inputRef }}
      country="br"
      localization={localization}
      inputClass={classes.input}
      buttonClass={classes.button}
      containerClass={classes.container}
      placeholder={isPortuguese ? '+55 (00) 00000000' : undefined}
      copyNumbersOnly
    />
  );
});

export default PhoneField;
